import React from 'react'
import { Link, generatePath } from 'react-router-dom'
import PropTypes from 'prop-types'
import { ROUTES } from '../../routes'
import TermAndConditionAgreementStatusLabel from '../../pages/shared/TermAndConditionAgreementStatusLabel'
import {
  AGREEMENT_STATUS,
  SIGNATURE_TRIGGER_OPTIONS,
  DELIVERY_OPTIONS
} from '../../pages/create-terms-and-condition-agreement/constants'
import styles from './TermsAndConditionAgreementList.module.scss'

function hasValue (value) {
  if (value == null) return false
  const text = String(value).trim()
  return text !== '' && text !== '—' && text !== '-'
}

function getSubtitleParts (agreement) {
  const parts = []
  const trigger = SIGNATURE_TRIGGER_OPTIONS[agreement.signatureTrigger] || agreement.triggerText
  const delivery = DELIVERY_OPTIONS[agreement.deliveryMethod] || agreement.deliveryMethodText

  if (hasValue(trigger)) parts.push(`Trigger: ${trigger}`)
  if (hasValue(delivery)) parts.push(delivery)
  if (hasValue(agreement.expirationText)) parts.push(agreement.expirationText)

  return parts
}

export default function TermsAndConditionAgreementList ({ agreement }) {
  const status = agreement.isEnabled ? AGREEMENT_STATUS.ENABLED : AGREEMENT_STATUS.DISABLED
  const isDraft = agreement.latestVersion?.status === 'draft'
  const isDefault = !!agreement.isDefault
  const subtitleParts = getSubtitleParts(agreement)

  return (
    <div className='list-group-item'>
      <div className={styles.agreementRow}>
        <div className={styles.agreementInfo}>
          <div className={`${styles.statusPill} inline-block status-pill`}>
            <TermAndConditionAgreementStatusLabel status={status} />
          </div>

          <div className={styles.agreementContent}>
            <h4 className={`${styles.agreementTitle} list-group-item-heading`}>
              {agreement.title}
              {isDefault && !isDraft && <span className={styles.defaultBadge}>DEFAULT</span>}
              {isDraft && <span className={styles.draftBadge}>DRAFT</span>}
            </h4>
            {subtitleParts.length > 0 && (
              <div className={styles.agreementSubtitle}>
                {subtitleParts.map((part, index) => (
                  <React.Fragment key={`${part}-${index}`}>
                    {index > 0 && <span className={styles.dot} aria-hidden='true'>·</span>}
                    {part}
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className={styles.agreementActions}>
          <Link
            className={`btn btn-primary-dk ${styles.actionBtn}`}
            to={generatePath(ROUTES.editTermsAndConditionAgreement, { id: agreement.id })}>
            <span className='pull-left hidden-xs'>EDIT</span>
            <i className='material-icons pull-right thumbster-button-icon no-margin-bs-xs'>mode_edit</i>
          </Link>
        </div>
      </div>
    </div>
  )
}

TermsAndConditionAgreementList.propTypes = {
  agreement: PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    title: PropTypes.string,
    isEnabled: PropTypes.bool,
    isDefault: PropTypes.bool,
    signatureTrigger: PropTypes.string,
    triggerText: PropTypes.string,
    deliveryMethod: PropTypes.string,
    deliveryMethodText: PropTypes.string,
    expirationText: PropTypes.string,
    latestVersion: PropTypes.shape({
      status: PropTypes.string
    })
  }).isRequired
}
